import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { Language } from "src/app/models/Language";

import { LocalizationService } from "./../../services/localization.service";

@Component({
  selector: "language-select",
  templateUrl: "./language-select.component.html",
  styleUrls: ["./language-select.component.scss"],
  standalone: false,
})
export class LanguageSelectComponent {
  placeholder: string = "Select language";
  subscription: Subscription;
  public languages: Language[];
  public currentLanguage: Language;

  constructor(public localizationService: LocalizationService) {
    this.languages = this.localizationService.languageList;
    this.currentLanguage = this.localizationService.currentLanguage;
  }

  onChange(code: string) {
    this.localizationService.setLocalization(code);
  }
}
